module.exports = __webpack_public_path__ + "img/signup_bk.2788bdea.png";